import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Rx = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="Rx icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path className={pathClass} d="M2 0H22L22 4L2 4L2 0Z" />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 6L4 6L4 22C4 23.1046 4.89543 24 6 24L18 24C19.1046 24 20 23.1046 20 22V6ZM15.5353 11.4644C14.7543 10.6834 13.4879 10.6834 12.7069 11.4644L11.2926 12.8788L14.1209 15.7071L12.7067 17.1213L9.87836 14.293L8.46424 15.7071C7.68319 16.4881 7.68319 17.7545 8.46424 18.5355C9.24529 19.3166 10.5116 19.3166 11.2927 18.5355L15.5353 14.2929C16.3164 13.5118 16.3164 12.2455 15.5353 11.4644Z"
    />
  </svg>
)
